module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.7231/img/callout-wave.svg"